import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import "./login.css"
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import React, {useState} from 'react';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { canAccessPage, setUserCookie } from '../../helper/token';

function Login() {
    
    //#region State management
    const SERVER_URL = process.env.REACT_APP_PROD_SERVER_URL;
    const [mode,setMode] = useState("Login");
    const [isLoginValidated, setIsLoginValidated] = useState(false);

    const navigate = useNavigate();
    let user = {};

    function changeMode(newMode)
    {
      if (newMode === "Login") 
      {
        setMode("Register");
      } 
      else 
      {
        setMode("Login");
      }
    }

    const notifySuccessful = (message) => {
      toast.success(message, {
        position: "bottom-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };

    const notifyFailed = (message) => {
      toast.error(message, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    };
  
    function onFormSubmitHandler(event){
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) 
        {
          event.preventDefault();
          event.stopPropagation();
        }
        else
        {
          user={username:event.target.elements.username.value,password:event.target.elements.password.value}

          axios
          .post(SERVER_URL+'/api/User/Login', user)
          .then((response) => {
            if (response.data === "No user found to log in with.") 
            {
              notifyFailed("Invalid Login Credentials.");
            }
            else
            {
              setUserCookie(response.data.token)
              notifySuccessful("Logged In!");
              setTimeout(() => {
                if(canAccessPage('Proposal')){
                  navigate('/home',{state:response.data});
                }else if(canAccessPage('Customer')){
                  navigate('/customerlistview',{state:response.data});
                }else if(canAccessPage('Invoice')){
                  navigate('/invoicelistview',{state:response.data});
                }else{
                  notifyFailed('You do not have access to any of the pages. Please contact system administartor')
                }
              }, 2000);
            }
          })
          .catch(error => {
            console.log(error);
            notifyFailed("Network error, please check your connection.");
          });
        }

        setIsLoginValidated(true);
    };
    //#endregion

    return (
      <div id="login-body">
        <ToastContainer />
        
        <div id="login-content">
            <div id="input-form">

                { mode === "Login" &&
                  <div id="login-section">
                    <img id="login-logo" src={require('./bciLogoNew.png')} alt="Not Found!" />
                    <Form noValidate validated={isLoginValidated} onSubmit={onFormSubmitHandler}>
                        <Form.Group className="mb-3" controlId="formBasicUsername">
                            <div className="login-input-container">
                              <h2>
                                Email
                              </h2>
                              <Form.Control 
                                id="username" 
                                placeholder="example@gmail.com"
                                type="email"
                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" 
                                required
                              />
                              <Form.Control.Feedback type="invalid">Please enter a valid email address</Form.Control.Feedback>
                            </div>
                            <div className="login-input-container">
                              <h2>
                                Password
                              </h2>
                              <Form.Control 
                                id="password" 
                                type="password" 
                                placeholder="Password"
                                required
                              />
                              <Form.Control.Feedback type="invalid">Please enter a valid registration number</Form.Control.Feedback>
                            </div>
                        </Form.Group>
                        <Button 
                          variant="primary" 
                          className="login-button" 
                          type="submit"
                        >
                            Login
                        </Button>
                    </Form>
                </div>
                }

                { mode === "Register" &&
                  <div id="login-section">
                    <img id="login-logo" src={require('./bciLogo.png')} alt="Not Found!" />
                    <Form onSubmit={onFormSubmitHandler}>
                        <Form.Group className="mb-3" controlId="formBasicUsername">
                            <h2>Username</h2>
                            <Form.Control id="username" type="Text" placeholder="example@gmail.com"></Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <h2>Email</h2>
                            <Form.Control id="password" type="password" placeholder="Password"></Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <h2>Password</h2>
                            <Form.Control id="password" type="password" placeholder="Password"></Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <h2>Confirm Password</h2>
                            <Form.Control id="password" type="password" placeholder="Password"></Form.Control>
                        </Form.Group>
                        <Button variant="primary" className="login-button" type="submit">
                            Register
                        </Button>
                    </Form>
                    <p className='login-secondary-action' onClick = {(e) => {changeMode("Register")}}>Already registered?</p>
                </div>
                }
                
            </div>
        </div>
      </div>
    );
  }
  
  export default Login;
  